import { render, staticRenderFns } from "./device.vue?vue&type=template&id=152e125f&scoped=true&"
import script from "./device.js?vue&type=script&lang=js&"
export * from "./device.js?vue&type=script&lang=js&"
import style0 from "./device.css?vue&type=style&index=0&id=152e125f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152e125f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
